import { render, staticRenderFns } from "./reverseTriangle.vue?vue&type=template&id=12a3a3d2&scoped=true"
import script from "./reverseTriangle.vue?vue&type=script&lang=js"
export * from "./reverseTriangle.vue?vue&type=script&lang=js"
import style0 from "./reverseTriangle.vue?vue&type=style&index=0&id=12a3a3d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a3a3d2",
  null
  
)

export default component.exports